var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.776,
    height: 35.313,
    viewBox: "848.984 2704.332 38.776 35.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39718"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m859.574 2722.02-5.293 7.068-5.297-7.062h3.507c.052-2.563.52-4.903 1.504-7.136 3.122-7.079 10.753-11.45 18.197-10.404 8.196 1.151 14.28 7.104 15.395 15.064 1.045 7.461-2.7 14.719-9.367 18.15-6.61 3.403-14.73 2.267-20.145-2.84-.35-.33-.694-.758-.828-1.204-.237-.787.029-1.507.768-1.94.804-.471 1.564-.32 2.226.319 1.675 1.613 3.61 2.779 5.843 3.453 7.825 2.363 16.088-2.485 17.818-10.462 1.727-7.967-3.67-15.783-11.712-16.963-8.095-1.188-15.662 4.924-16.095 12.965-.043.8.171 1.067.961 1.005.742-.058 1.493-.012 2.518-.012Z",
    fill: "#9997df",
    fillRule: "evenodd",
    "data-name": "Path 78003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.61 2718.378c0-1.66-.01-3.322.003-4.982.008-1.203.735-1.995 1.783-1.98 1.016.014 1.718.774 1.725 1.934.016 2.538.05 5.077-.015 7.613-.024.907.292 1.11 1.12 1.073 1.343-.059 2.692-.026 4.039-.01 1.155.013 1.919.707 1.935 1.72.016 1.05-.772 1.784-1.971 1.79-2.224.012-4.448.015-6.671-.001-1.306-.01-1.935-.658-1.945-1.988-.013-1.723-.003-3.446-.003-5.17Z",
    fill: "#9997df",
    fillRule: "evenodd",
    "data-name": "Path 78004"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/Free.e121cf58ebd7cdc6a877cbcb28461808.svg";
export { ForwardRef as ReactComponent };